// @flow
import reviewsService from './reviewsService';
import type { GetReviewsRequest, GetReviewCategoriesRequest, CreateOrUpdateRetortRequest } from './reviewsService';
import reviewsActionKeys from './reviewsActionKeys';

export const API_LIMIT = 10;

const getReviews = (
  serviceProviderId: string,
  categoryId: number,
  starRatingFilters: number[],
  sortDirection: string,
  sortType: string,
  offset: number = 0,
  markReviewsRead: boolean = false,
): {|
  meta: {|markReviewsRead: boolean|},
  payload: {|data: GetReviewsRequest, promise: any|},
  type: string,
|} => ({
  type: reviewsActionKeys.GET_REVIEWS,
  meta: {
    markReviewsRead,
  },
  payload: {
    data: ({
      serviceProviderId,
      categoryId: categoryId !== 0 ? categoryId : undefined,
      starRatingFilters,
      sortDirection,
      sortType,
      limit: API_LIMIT,
      offset,
    }: GetReviewsRequest),
    promise: reviewsService.getReviews(
      serviceProviderId,
      categoryId !== 0 ? categoryId : undefined,
      starRatingFilters,
      sortDirection,
      sortType,
      API_LIMIT,
      offset,
    ),
  },
});

const getReviewCategories = (serviceProviderId: string):
{|payload: {|data: GetReviewCategoriesRequest, promise: any|}, type: string|} => ({
  type: reviewsActionKeys.GET_REVIEW_CATEGORIES,
  payload: {
    data: ({
      serviceProviderId,
    }: GetReviewCategoriesRequest),
    promise: reviewsService.getReviewCategories(serviceProviderId),
  },
});

const createOrUpdateRetort = (serviceProviderId: string, reviewId: string, text: string):
{|payload: {|data: CreateOrUpdateRetortRequest, promise: any|}, type: string|} => ({
  type: reviewsActionKeys.CREATE_OR_UPDATE_RETORT,
  payload: {
    data: ({
      serviceProviderId,
      reviewId,
      text,
    }: CreateOrUpdateRetortRequest),
    promise: reviewsService.createOrUpdateRetort(serviceProviderId, reviewId, text),
  },
});

const markReviewsRead = (serviceProviderId: string, lastReadReviewId: number): {|
  payload: {|
    data: {|lastReadReviewId: number, serviceProviderId: string|},
    promise: any,
  |},
  type: string,
|} => ({
  type: reviewsActionKeys.MARK_REVIEWS_READ,
  payload: {
    data: {
      serviceProviderId,
      lastReadReviewId,
    },
    promise: reviewsService.markReviewsRead(serviceProviderId, lastReadReviewId),
  },
});

export default {
  getReviews,
  getReviewCategories,
  createOrUpdateRetort,
  markReviewsRead,
};



// WEBPACK FOOTER //
// ./src/modules/store/common/reviewsActions.js